import { useMutation } from '@apollo/client';
import Snackbar from '~/components/Snackbar';
import { useAuth } from '~/context/auth';
import { LIKE_COMMENT, REMOVE_LIKE_FROM_COMMENT } from '../operations/post';

type PollVoteHookProps = {
  onLikeComment: (commentId: string, liked: boolean) => void;
};

const useLikeComment = (): PollVoteHookProps => {
  const [likeComment] = useMutation(LIKE_COMMENT);
  const [removeLikeFromComment] = useMutation(REMOVE_LIKE_FROM_COMMENT);

  const { authUserGroupId } = useAuth();

  const onLikeComment = async (commentId: string, liked: boolean) => {
    try {
      if (liked) {
        await removeLikeFromComment({
          variables: {
            input: {
              id: commentId,
            },
            authUserGroupId,
          },
        });
      } else {
        await likeComment({
          variables: {
            input: {
              id: commentId,
            },
            authUserGroupId,
          },
        });
      }
    } catch (e) {
      if (e instanceof Error) {
        Snackbar.show(e.message);
      }
    }
  };
  return {
    onLikeComment,
  };
};

export default useLikeComment;
